import type { FrontendConfig } from '../types.js';

export const ssgConfig: FrontendConfig = {
  sentryEnabled: true,
  backendUrl: 'https://grove-api.alveole.buzz',
  webAppUrl: 'https://app.alveole.com',
  auth0Domain: '',
  auth0ManagementDomain: '',
  auth0ClientId: '',
  auth0Audience: '',
  postHogEnabled: true,
  postHogKey: 'phc_fK1Skgq0zNTqhrxnhna9A6sZIGxP6gYx1BFqhs8zjlg',
  postHogHost: 'https://us.i.posthog.com',
  envName: 'ssg',
  mapboxAccessToken: 'pk.eyJ1IjoiYWx2ZW9sZS1wcm9kdWN0IiwiYSI6ImNtbmdmZmh1bTA4ZnYyc3B0dDBjcGRkdGoifQ.z1v4lIXV2xnDK4lH3WUNwQ',
};
